import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Dialog, DIALOG_DATA, DialogRef, DialogModule} from '@angular/cdk/dialog';
import { Subscription } from 'rxjs';

export interface ModalDialogData {	 
	title : string;
	content : string;
	acceptButtonText : string;
	cancelButtonText : string;
	acceptClicked : (event? : any) => void;
	cancelClicked : (event? : any) => void;
	showCloseButton? : boolean;
	showCancelButton? : boolean;	
}



@Component({
	selector: 'app-modal-dialog',
	templateUrl: './modal-dialog.component.html',
	styleUrls: ['./modal-dialog.component.scss']	
})
export class ModalDialogComponent implements OnInit, OnDestroy {
	private eventSub : Subscription;
	private backdropSub : Subscription;

	constructor(@Inject(DIALOG_DATA) public data : ModalDialogData, public dialogRef: DialogRef) 
	{

	}

	ngOnInit(): void {
		this.eventSub = this.dialogRef?.keydownEvents?.subscribe((event : any) => {
			if (event.key === "Escape") 
			{
				this.closeDialog();
				if("function" === typeof(this.data?.cancelClicked))
				{
					this.data?.cancelClicked(event);
				}
			}
		});
	
		this.backdropSub = this.dialogRef?.backdropClick?.subscribe( (event : any) => {
			this.closeDialog();
			if("function" === typeof(this.data?.cancelClicked))
			{
				this.data?.cancelClicked(event);
			}
		});
	}


	ngOnDestroy(): void {
		this.eventSub && this.eventSub?.unsubscribe();
		this.backdropSub && this.backdropSub?.unsubscribe();
	}

	public onAcceptClicked = (event : any) => {
		this.closeDialog();
		if("function" === typeof(this.data?.acceptClicked))
		{
			this.data?.acceptClicked(event);
		}
	}

	public onCancelClicked = (event : any) => {
		this.closeDialog();
		if("function" === typeof(this.data?.cancelClicked))
		{
			this.data?.cancelClicked(event);
		}
	}

	private closeDialog = () => {
		this.dialogRef?.close();
	}
}
